<div class="dialog-header">
  <span class="spacer"></span>
  <label class="header-label">User Performance Defaults</label>
  <span class="spacer"></span>
  <button matButton="elevated" class="close-dialog-button warn-button" (click)="close()">
    X
  </button>
</div>
<div class="content">
  <app-user-performance-defaults (errorEvent)="handleError($event)">
  </app-user-performance-defaults>
</div>
@if (isBusy) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
